export default __webpack_public_path__ + "static/media/rightdotT.b7155727.png";